import { render, staticRenderFns } from "./FilterPrice.vue?vue&type=template&id=0f16d6da&"
import script from "./FilterPrice.vue?vue&type=script&lang=js&"
export * from "./FilterPrice.vue?vue&type=script&lang=js&"
import style0 from "./FilterPrice.vue?vue&type=style&index=0&id=0f16d6da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports